import type { Kitchen } from '@rta/rta-blueprint-library';

import { getIslandAddonState, LEVELING_LEGS_SKU } from './island-addons';

export { LEVELING_LEGS_SKU };

export type HasLevelingLegsParams = {
	kitchen: Kitchen;
	/** When given, that island's own add-on state decides; omitted keeps the kitchen-wide read. */
	islandId?: string | null;
};

// Exact wording the BP team hand-typed on the real #727/#728 design — 'the panel', not 'each panel'.
export const LEVELING_LEGS_PANEL_NOTE = 'MFG: Add leveling legs at the bottom of the panel';

export const hasLevelingLegs = (params: HasLevelingLegsParams): boolean => {
	const { kitchen, islandId = null } = params;

	if (islandId !== null) {
		const island = kitchen.design.islands.children.find(({ id }) => id === islandId) ?? null;
		if (island) return getIslandAddonState(kitchen, island, 'levelingLegs');
	}

	const target = LEVELING_LEGS_SKU.toLowerCase();
	return (kitchen.accessories?.children ?? []).some((accessory) => (accessory.sku ?? '').toLowerCase() === target);
};
